module.exports = __webpack_public_path__ + "static/NL-948920bf329d4022d057d1daf8eff2c7.jpg";